import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getStoredAuthToken } from '../utils/authTokens';

const HeroSection = () => {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();

  const handleStartAnalysis = () => {
    const token = getStoredAuthToken({ preferAdmin: false });
    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/signup');
    }
  };

  const handleSeeLiveDemo = () => {
    // Navigate to hero section (top of page)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="hero-gradient pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Full-width Video Section */}
        <div className="w-full mb-8">
          <div className="animate-float">
            <div className="relative w-full">
              <video
                className="w-full h-auto rounded-2xl shadow-xl border border-gray-100 max-h-screen"
                autoPlay
                muted
                loop
                controls
                playsInline
                poster="/images/hero-video-poster.jpg"
              >
                <source src="/videos/hero.mp4" type="video/mp4" />
                {/* Fallback content when video is not available */}
                <div className="relative bg-white p-6 rounded-2xl shadow-xl border border-gray-100">
                  <div className="flex justify-between items-center mb-6">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <i className="fas fa-hard-hat text-blue-600"></i>
                      </div>
                      <div className="ml-3">
                        <div className="text-sm font-medium text-gray-900">FIDIC Contract Analysis</div>
                        <div className="text-xs text-gray-500">Construction Standards</div>
                      </div>
                    </div>
                    <div className="text-xs px-2 py-1 bg-green-100 text-green-800 rounded-full">AI Processing</div>
                  </div>
                  <div className="mb-6">
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden mb-1">
                      <div className="h-full bg-blue-600 rounded-full w-3/4"></div>
                    </div>
                    <div className="text-xs text-gray-500 text-right">75% complete</div>
                  </div>
                  <div className="space-y-4">
                    <div className="p-3 bg-blue-50 rounded-lg border-l-4 border-blue-600">
                      <div className="flex justify-between">
                        <div className="font-medium text-gray-900">Performance Security</div>
                        <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">FIDIC Compliant</div>
                      </div>
                      <div className="text-sm text-gray-600 mt-1">10% of contract value - standard for GCC projects.</div>
                    </div>
                    <div className="p-3 bg-red-50 rounded-lg border-l-4 border-red-500">
                      <div className="flex justify-between">
                        <div className="font-medium text-gray-900">Delay Penalties</div>
                        <div className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">Risk Alert</div>
                      </div>
                      <div className="text-sm text-gray-600 mt-1">Penalty cap may exceed local law limits - requires review.</div>
                    </div>
                    <div className="p-3 bg-yellow-50 rounded-lg border-l-4 border-yellow-500">
                      <div className="flex justify-between">
                        <div className="font-medium text-gray-900">Force Majeure</div>
                        <div className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">UAE Law</div>
                      </div>
                      <div className="text-sm text-gray-600 mt-1">Clause aligned with UAE Civil Code provisions.</div>
                    </div>
                  </div>
                </div>
              </video>
            </div>
          </div>
        </div>
        
        {/* Buttons Section Below Video */}
        <div className="flex justify-center">
          <div className={`flex flex-col sm:flex-row space-y-4 sm:space-y-0 ${isRTL ? 'sm:space-x-reverse' : ''} sm:space-x-4 animate-slide-up`}>
            <button 
              onClick={handleStartAnalysis}
              className="px-8 py-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition shadow-lg text-center text-lg"
            >
              {isRTL ? 'ابدأ التحليل المجاني' : 'Start Free Analysis'}
            </button>
     
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
